/* eslint-disable */
import React, {Component} from 'react';
import Loader from 'react-loader';

export default class Disciplines extends Component {

    componentDidMount() {
        this.props.fetchAllDisciplines();
        window.scrollTo(0, 0);
    }

    render() {
        const {isLoading, disciplines} = this.props;
        return (
            <Loader
                color="#7b2b2a"
                loaded={!isLoading}
            >
                <div className="25.jpg upper">
                    <div className="captions">Дисциплины</div>
                    <table className="tg-second new__tg new__tg_center_second">
                        <thead>
                        <tr>
                            <th style={{width: '50%'}}>Дисциплины</th>
                            <th>Курсы</th>
                            <th>Семестры</th>
                            <th>Всего часов</th>
                            <th>Контроль</th>
                            <th>УМК</th>
                        </tr>
                        </thead>
                        <tbody>
                        {disciplines && disciplines.map(discipline => (
                            <tr key={discipline.cid}>
                                <td>{discipline.course}</td>
                                <td>1, 3</td>
                                <td>1, 2, 5</td>
                                <td>48</td>
                                <td>ЗО, ЗО, Э</td>
                                <td>
                                    <div className="td__block"/>
                                </td>
                            </tr>
                        ))}
                        </tbody>

                        {/*<tr>*/}
                        {/*<td>История</td>*/}
                        {/*<td>1,3</td>*/}
                        {/*<td>1, 2, 5</td>*/}
                        {/*<td>48</td>*/}
                        {/*<td>ЗО, ЗО, Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>История Отечества</td>*/}
                        {/*<td>1</td>*/}
                        {/*<td>2</td>*/}
                        {/*<td>30</td>*/}
                        {/*<td>ЗБО</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Математический анализ</td>*/}
                        {/*<td>4</td>*/}
                        {/*<td>7, 8</td>*/}
                        {/*<td>102</td>*/}
                        {/*<td>ЗО, Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Философия</td>*/}
                        {/*<td>1, 2</td>*/}
                        {/*<td>2, 3</td>*/}
                        {/*<td>60</td>*/}
                        {/*<td>ЗБО, Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Аналитическая геометрия и линейная алгебра</td>*/}
                        {/*<td>1</td>*/}
                        {/*<td>2</td>*/}
                        {/*<td>148</td>*/}
                        {/*<td>ЗО</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Криминалистика</td>*/}
                        {/*<td>4, 5</td>*/}
                        {/*<td>8, 9</td>*/}
                        {/*<td>80</td>*/}
                        {/*<td>ЗО, Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Физика твердых тел</td>*/}
                        {/*<td>2</td>*/}
                        {/*<td>4</td>*/}
                        {/*<td>24</td>*/}
                        {/*<td>Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Физика</td>*/}
                        {/*<td>3</td>*/}
                        {/*<td>6</td>*/}
                        {/*<td>96</td>*/}
                        {/*<td>Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*<td>Военная топография</td>*/}
                        {/*<td>4</td>*/}
                        {/*<td>7</td>*/}
                        {/*<td>78</td>*/}
                        {/*<td>Э</td>*/}
                        {/*<td><div className="td__block" /></td>*/}
                        {/*</tr>*/}
                    </table>
                </div>
            </Loader>
        );
    }
}

